module.exports = "https://www.gc-pro.gnp.com.mx/7f35733f30ec066e1c512a69e143c9b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/muelita.svg
// module id = 8153
// module chunks = 0